import type { FieldError } from 'react-hook-form';

/**
 * Small presentational form-field primitives the editor sections compose (PLAN.md M7 — "inline
 * errors"). They render a label + control + the inline validation error from react-hook-form. The
 * actual `register(...)` wiring is done by the section components; these just lay out the field.
 */

export interface FieldProps {
  label: string;
  error?: FieldError | undefined;
  htmlFor?: string | undefined;
  children: React.ReactNode;
  /** Optional helper note under the control. */
  hint?: string | undefined;
}

export function Field({ label, error, htmlFor, children, hint }: FieldProps): React.ReactElement {
  return (
    <div style={{ marginBottom: 'var(--sp-4)' }}>
      <label className="field__label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {hint !== undefined && error === undefined && (
        <span style={{ fontSize: 'var(--fs-small)', color: 'var(--ink-muted)' }}>{hint}</span>
      )}
      {error !== undefined && <span className="field__error">{error.message}</span>}
    </div>
  );
}

/** Two- or three-column field row for dense forms. */
export function FieldRow({ children }: { children: React.ReactNode }): React.ReactElement {
  return <div style={{ display: 'flex', gap: 'var(--sp-4)', flexWrap: 'wrap' }}>{children}</div>;
}
